import { request } from "@/utils/request";
// 查询
export function selectApi(data) {
  return request({
    url: `/public/wechatNotify/sendAccount/select`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

// 新增
export function addApi(data) {
  return request({
    url: `/public/wechatNotify/sendAccount/add`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

/* 修改 */
export function updateApi(data) {
  return request({
    url: `/public/wechatNotify/sendAccount/update`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

// 删除
export function deleteApi(data) {
  return request({
    url: `/public/wechatNotify/sendAccount/delete`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

// 获取公众号当前粉丝数，并保存到数据库
export function getFansNumApi(data) {
  return request({
    url: `/public/wechatNotify/sendAccount/getFansNum`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}